export function isScalar(v: any): boolean {
    return typeof v !== 'object' && v !== null && v !== undefined;
}
export function isBool(v: any): boolean {
    return typeof v === 'boolean';
}

export function isString(v: any): boolean {
    return typeof v === 'string';
}

export function isNumber(v: any): boolean {
    return typeof v === 'number';
}

export function isInteger(v: any): boolean {
    return Number.isInteger(v);
}

/** those functions will returns undefined if failed to convert */
export function toString(v: any): string|undefined {
    return isScalar(v) ? v.toString() : undefined;
}

export function toBool(v: any): boolean|undefined {
    if (!isBool(v)) {
        if (isScalar(v)) {
            v = (toString(v) as string).toLowerCase();
            return { 'true': true, 'false': false }[v as string];
        }
        return undefined;
    }
    return v;
}

export function toNumber(v: any): number|undefined {
    v = parseFloat(v);
    return isNaN(v) ? undefined : v;
}
